/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { Progress } from 'reactstrap';
import classNames from 'classnames';
import { getStepTitle, OnboardingStep } from '../../types/onboarding';
import './styles.scss';

interface CustomStepperProps {
  steps: OnboardingStep[];
  current: OnboardingStep;
}

const CustomStepper = (props: CustomStepperProps) => {
  const { steps, current } = props;

  const progressPosition = steps.findIndex((step) => step === current);
  const totalSteps = steps.length;
  const progress = (progressPosition + 1) / totalSteps;

  const renderStep = (customStepperStep: OnboardingStep, key: number) => {
    const customStepperPosition = steps.findIndex((step) => step === customStepperStep);

    const isCurrentStep = customStepperPosition === progressPosition;
    const done = customStepperPosition <= progressPosition;
    //This is when activeSte === 2 and progress bar is mid way to step 3 rendering the Loading bar while api request is resolved
    const halfwayProgress = progress === 50 && isCurrentStep;

    return (
      <li className='stepper-step' key={key}>
        <div className='label-container'>
          <span className={classNames({
            'stepper-step-index': true,
            'current-step': isCurrentStep && !halfwayProgress,
            'done': done || halfwayProgress,
          })}>
          </span>
          <p className='stepper-step-label mt-3'>{getStepTitle(customStepperStep)}</p>
        </div>
        {!!key ? <Progress value={customStepperPosition <= progressPosition ? 100 : 0} min={0} max={100}  /> : null}
      </li>
    )
  }

  return (
    <div className='stepper-container mt-5'>
      <ul className='stepper'>
        {steps.map(renderStep)}
      </ul>
    </div>
  )
}

export default CustomStepper;
